import { FULL_HD, HD } from '@bedrock-rdk/constants';
import { getFont, FONT } from '@tornado-rdk/typography';
import {
  CATCH_PHRASE_FONT,
  CATCH_PHRASE_FONT_TYPE,
  LOGO_ICON_SCALE,
  CATCH_PHRASE_MAX_LINES,
  WORD_WRAP_WIDTH,
  PADDING_TOP,
  JUSTIFY_CONTENT,
} from './landing.constants';
import { SCREEN_WIDTH, SCREEN_HEIGHT, identity } from '../tornado/utils/sizes';
import { makeDefaultStylingContext } from '../tornado/utils/style';
import { getBackgroundUrl } from './landing.utils';

export const defaultContext = makeDefaultStylingContext();

export { WORD_WRAP_WIDTH, PADDING_TOP };

export const PADDING_LEFT = {
  [HD]: 64,
  [FULL_HD]: 80,
};

export const LOGO_HEIGHT = {
  [HD]: 152,
  [FULL_HD]: 152,
};

export const LOGO_MARGIN_BOTTOM = {
  [HD]: 0,
  [FULL_HD]: 0,
};

export const TEXT_MARGIN_BOTTOM = {
  [HD]: 16,
  [FULL_HD]: 16,
};

export const TEXT_MARGIN_TOP = {
  [HD]: 32,
  [FULL_HD]: 64,
};

export const BUTTONS_MARGIN_TOP = {
  [HD]: 32,
  [FULL_HD]: 64,
};

export const getLogoViewBox = screenSize => ({
  h: LOGO_HEIGHT[screenSize],
});

export const getInitialStyle = (context = defaultContext) => {
  const { screenSize = FULL_HD } = context;

  const wordWrapWidth = WORD_WRAP_WIDTH[screenSize];

  return {
    Root: {
      visible: false,
      w: SCREEN_WIDTH[screenSize],
      h: SCREEN_HEIGHT[screenSize],
      Background: {
        w: SCREEN_WIDTH[screenSize],
        h: SCREEN_HEIGHT[screenSize],
        src: getBackgroundUrl(screenSize),
        alpha: 0.001,
        scale: 1.05,
        zIndex: 1,
      },
      Overlay: {
        w: identity,
        h: identity,
        zIndex: 2,
      },
      Content: {
        x: PADDING_LEFT[screenSize],
        h: SCREEN_HEIGHT[screenSize],
        y: PADDING_TOP[screenSize],
        flex: {
          justifyContent: JUSTIFY_CONTENT,
          direction: 'column',
        },
        zIndex: 3,
        Logo: {
          h: LOGO_HEIGHT[screenSize],
          textureScale: LOGO_ICON_SCALE,
          flexItem: {
            marginBottom: LOGO_MARGIN_BOTTOM[screenSize],
          },
        },
        CatchPhrase: {
          text: {
            ...getFont(CATCH_PHRASE_FONT, screenSize, CATCH_PHRASE_FONT_TYPE),
            maxLines: CATCH_PHRASE_MAX_LINES,
            textOverflow: '...',
            wordWrapWidth,
          },
          flexItem: {
            marginTop: TEXT_MARGIN_TOP[screenSize],
            marginBottom: TEXT_MARGIN_BOTTOM[screenSize],
          },
        },
        Description: {
          text: {
            ...getFont(FONT.KINSHASA_3, screenSize),
            maxLines: 3,
            wordWrapWidth,
          },
          flexItem: {
            marginBottom: TEXT_MARGIN_BOTTOM[screenSize],
          },
        },
        Pricing: {
          text: {
            ...getFont(FONT.OTTAWA_2, screenSize),
            maxLines: 3,
            wordWrapWidth,
          },
        },
        Buttons: {
          flexItem: {
            marginTop: BUTTONS_MARGIN_TOP[screenSize],
          },
        },
      },
    },
  };
};
